import { z } from "zod";

const envSchema = z.object({
  VITE_API_BASE_URL: z.string().url(),
  VITE_BASE_URL: z.string().url(),
  VITE_AUTH_API_BASE_URL: z.string().url(),
  VITE_PROKER_API_BASE_URL: z.string().url(),
});

export const env = envSchema.parse(import.meta.env);
